import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './layout/navbar/Navbar';
import { useEffect, useState, lazy, Suspense } from 'react';

const Home = lazy(() => import('./Pages/Dashboard/Home'));
const WaytrixLogin = lazy(() => import('./Pages/WaytrixAccount/WaytrixLogin'));
const AddResto = lazy(() => import('./Pages/WaytrixAccount/AddResto'));
const AddTableOrValet = lazy(() => import('./Pages/WaytrixAccount/AddTableOrValet/AddTableOrValet'));
const GetTableAccounts = lazy(() => import('./Pages/WaytrixAccount/AddWaiter/getTableAccounts'));
const AddWaiter = lazy(() => import('./Pages/WaytrixAccount/AddWaiter/AddWaiter'));
const GetRestoAcounts = lazy(() => import('./Pages/WaytrixAccount/AddVideo/GetRestoAccounts'));
const AddVideo = lazy(() => import('./Pages/WaytrixAccount/AddVideo/AddVideo'));
const AddPartners = lazy(() => import('./Pages/WaytrixAccount/Partners/AddPartners'));
const DeletePartners = lazy(() => import('./Pages/WaytrixAccount/Partners/DeletePartner'));
const AddVoucher = lazy(() => import('./Pages/WaytrixAccount/AddVoucher/AddVoucher'));
const AddButtons = lazy(() => import('./Pages/WaytrixAccount/AddButtons/AddButtons'));
const GetRestoAccountButtons = lazy(() => import('./Pages/WaytrixAccount/AddButtons/GetRestoAccounts'));
const TableLocations = lazy(() => import('./Pages/WaytrixAccount/TableLocations/TableLocations'));
const AddCustomButtons = lazy(() => import('./Pages/WaytrixAccount/AddCustomButtons/GetRestoAccounts'));
const AddCustomButtonsScreen = lazy(() => import('./Pages/WaytrixAccount/AddCustomButtons/AddCustomButtons'));
const GetCustomButtons = lazy(() => import('./Pages/WaytrixAccount/AddCustomButtons/GetCustomButtons'));
const GetAllRestoForVidPrev = lazy(() => import('./Pages/WaytrixAccount/VideoPrev/GetAllResto'));
const VidPrevScreen = lazy(() => import('./Pages/WaytrixAccount/VideoPrev/VidPreview'));
const GetRestoForAddTableOrValet = lazy(() => import('./Pages/WaytrixAccount/AddTableOrValet/GetRestoAccounts'));
const GetRestoAccountForVideoUpdate = lazy(() => import('./Pages/WaytrixAccount/AddVideo/UpdateVideo/GetRestoAccounts'));
const GetForLoopId = lazy(() => import('./Pages/WaytrixAccount/AddVideo/UpdateVideo/GetForLoopId'));
const GetRestoAccountForDelete = lazy(() => import('./Pages/WaytrixAccount/DeleteResto/GetRestoAccountForDelete'));
const NavResto = lazy(() => import('./Pages/Dashboard/NavResto/NavResto'));
const Details = lazy(() => import('./Pages/Dashboard/NavResto/Details'));
const Tablets = lazy(() => import('./Pages/Dashboard/NavResto/Tablets'));
const AddTablet = lazy(() => import('./Pages/Dashboard/NavResto/AddTablet'));
const Valet = lazy(() => import('./Pages/Dashboard/NavResto/Valet'));
const AddValet = lazy(() => import('./Pages/Dashboard/NavResto/AddValet'));
const Sequence = lazy(() => import('./Pages/Dashboard/NavResto/Sequence'));
const AddVideoSeq = lazy(() => import('./Pages/Dashboard/NavResto/AddVideoSeq'));
const Watches = lazy(() => import('./Pages/Dashboard/NavResto/Watches'));
const AddWatch = lazy(() => import('./Pages/Dashboard/NavResto/AddWatch'));
const AddButtons2 = lazy(() => import('./Pages/Dashboard/NavResto/AddButtons2'));
const EditVoucher = lazy(() => import('./Pages/WaytrixAccount/AddVoucher/EditVoucher'));
const PopupForms = lazy(() => import('./Pages/WaytrixAccount/PopupForms/PopupForms'));
const PopupFormsList = lazy(() => import('./Pages/WaytrixAccount/PopupForms/PopupFormsList'));
const PopupFormSubmissions = lazy(() => import('./Pages/WaytrixAccount/PopupForms/PopupFormSubmissions'));
const PopupFormCreatePage = lazy(() => import('./Pages/WaytrixAccount/PopupForms/PopupFormCreatePage'));
const SpinAnalytics = lazy(() => import('./Pages/WaytrixAccount/SpinAnalytics/SpinAnalytics'));
const MultipleVideos = lazy(() => import('./Pages/WaytrixAccount/MultipleVideos/MultipleVideos'));
const SurveyConfigRestos = lazy(() => import('./Pages/WaytrixAccount/SurveyConfig/GetRestoAccounts'));
const EditSurveyConfig = lazy(() => import('./Pages/WaytrixAccount/SurveyConfig/EditSurveyConfig'));
const WorldCup = lazy(() => import('./Pages/WaytrixAccount/WorldCup/WorldCup'));
const CustomerInsights = lazy(() => import('./Pages/WaytrixAccount/CustomerInsights/CustomerInsights'));

function App() {
  const [waytrixToken, setWaytrixToken] = useState(localStorage.getItem('waytrixToken') || '');

  useEffect(() => {
    const handleTokenChange = () => {
      setWaytrixToken(localStorage.getItem('waytrixToken') || '');
    };
    window.addEventListener('storage', handleTokenChange);
    window.addEventListener('waytrixTokenChange', handleTokenChange);
    return () => {
      window.removeEventListener('storage', handleTokenChange);
      window.removeEventListener('waytrixTokenChange', handleTokenChange);
    };
  }, []);

  return (
    <div className="App">
      <Router>
        <Navbar />
        <Suspense fallback={<div className="app-loading">Loading…</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            {waytrixToken ?
              <>
                <Route path="/WaytrixLogin" element={<Home />} />
                <Route path="/AddResto" element={<AddResto />} />
                <Route path="/GetRestoAcounts" element={<GetRestoAcounts />} />
                <Route path="/AddVideo/:id" element={<AddVideo />} />
                <Route path="/NavResto" element={<NavResto />} />
                <Route path="/restaurant/:id" element={<Details />} />
                <Route path="/Tablets" element={<Tablets />} />
                <Route path="/AddWatch" element={<AddWatch />} />
                <Route path="/Sequence" element={<Sequence />} />
                <Route path="/AddVideoSeq" element={<AddVideoSeq />} />
                <Route path="/Valet" element={<Valet />} />
                <Route path="/Watches" element={<Watches />} />
                <Route path="/AddValet" element={<AddValet />} />
                <Route path="/AddTablet" element={<AddTablet />} />
                <Route path="/AddPartners" element={<AddPartners />} />
                <Route path="/DeletePartners" element={<DeletePartners />} />
                <Route path="/AddVoucher" element={<AddVoucher />} />
                <Route path="/AddButtons/:id" element={<AddButtons />} />
                <Route path="/GetRestoAccountButtons" element={<GetRestoAccountButtons />} />
                <Route path="/TableLocations" element={<TableLocations />} />
                <Route path="/AddCustomButtons" element={<AddCustomButtons />} />
                <Route path="/AddCustomButtonsScreen/:id" element={<AddCustomButtonsScreen />} />
                <Route path="/GetCustomButtons/:id" element={<GetCustomButtons />} />
                <Route path="/GetAllRestoForVidPrev" element={<GetAllRestoForVidPrev />} />
                <Route path="/VidPrevScreen/:id" element={<VidPrevScreen />} />
                <Route path="/GetRestoForAddTableOrValet" element={<GetRestoForAddTableOrValet />} />
                <Route path="/AddTableOrValet/:restoId" element={<AddTableOrValet />} />
                <Route path="/getTableAccounts" element={<GetTableAccounts />} />
                <Route path="/AddWaiter/:restoId/:tableId" element={<AddWaiter />} />
                <Route path="/GetRestoAccountForVideoUpdate" element={<GetRestoAccountForVideoUpdate />} />
                <Route path="/GetForLoopId/:id" element={<GetForLoopId />} />
                <Route path="/GetRestoAccountForDelete" element={<GetRestoAccountForDelete />} />
                <Route path="/AddButtons2" element={<AddButtons2 />} />
                <Route path="/EditVoucher" element={<EditVoucher />} />
                <Route path="/popup-forms" element={<PopupForms />} />
                <Route path="/popup-forms/create" element={<PopupFormCreatePage />} />
                <Route path="/popup-forms/:type" element={<PopupFormsList />} />
                <Route path="/popup-forms/:type/:popupFormId/submissions" element={<PopupFormSubmissions />} />
                <Route path="/spin-analytics" element={<SpinAnalytics />} />
                <Route path="/multiple-videos" element={<MultipleVideos />} />
                <Route path="/SurveyConfig" element={<SurveyConfigRestos />} />
                <Route path="/EditSurveyConfig/:id" element={<EditSurveyConfig />} />
                <Route path="/WorldCup" element={<WorldCup />} />
                <Route path="/CustomerInsights" element={<CustomerInsights />} />
              </>
              :
              <>
                <Route path="/popup-forms" element={<WaytrixLogin />} />
                <Route path="/popup-forms/create" element={<WaytrixLogin />} />
                <Route path="/popup-forms/:type" element={<WaytrixLogin />} />
                <Route path="/popup-forms/:type/:popupFormId/submissions" element={<WaytrixLogin />} />
                <Route path="/spin-analytics" element={<WaytrixLogin />} />
                <Route path="/multiple-videos" element={<WaytrixLogin />} />
                <Route path="/SurveyConfig" element={<WaytrixLogin />} />
                <Route path="/EditSurveyConfig/:id" element={<WaytrixLogin />} />
                <Route path="/WorldCup" element={<WaytrixLogin />} />
                <Route path="/CustomerInsights" element={<WaytrixLogin />} />
                <Route path="/AddResto" element={<WaytrixLogin />} />
                <Route path="/WaytrixLogin" element={<WaytrixLogin />} />
                <Route path="/GetRestoAcounts" element={<WaytrixLogin />} />
                <Route path="/AddVideo/:id" element={<WaytrixLogin />} />
                <Route path="/AddPartners" element={<WaytrixLogin />} />
                <Route path="/DeletePartners" element={<WaytrixLogin />} />
                <Route path="/AddVoucher" element={<WaytrixLogin />} />
                <Route path="/EditVoucher" element={<WaytrixLogin />} />
                <Route path="/AddButtons/:id" element={<WaytrixLogin />} />
                <Route path="/AddButtons2" element={<WaytrixLogin />} />
                <Route path="/AddButtons2/:id" element={<WaytrixLogin />} />
                <Route path="/GetRestoAccountButtons" element={<WaytrixLogin />} />
                <Route path="/TableLocations" element={<WaytrixLogin />} />
                <Route path="/AddCustomButtons" element={<WaytrixLogin />} />
                <Route path="/AddCustomButtonsScreen/:id" element={<WaytrixLogin />} />
                <Route path="/GetCustomButtons/:id" element={<WaytrixLogin />} />
                <Route path="/GetAllRestoForVidPrev" element={<WaytrixLogin />} />
                <Route path="/VidPrevScreen/:id" element={<WaytrixLogin />} />
                <Route path="/AddTableOrValet/:restoId" element={<WaytrixLogin />} />
                <Route path="/GetRestoForAddTableOrValet" element={<WaytrixLogin />} />
                <Route path="/getTableAccounts" element={<WaytrixLogin />} />
                <Route path="/AddWaiter/:restoId/:tableId" element={<WaytrixLogin />} />
                <Route path="/GetRestoAccountForVideoUpdate" element={<WaytrixLogin />} />
                <Route path="/GetForLoopId/:id" element={<WaytrixLogin />} />
                <Route path="/GetRestoAccountForDelete" element={<WaytrixLogin />} />
                <Route path="/NavResto" element={<WaytrixLogin />} />
                <Route path="/restaurant/:id" element={<WaytrixLogin />} />
                <Route path="/Tablets" element={<WaytrixLogin />} />
                <Route path="/AddTablet" element={<WaytrixLogin />} />
                <Route path="/Valet" element={<WaytrixLogin />} />
                <Route path="/AddValet" element={<WaytrixLogin />} />
                <Route path="/Sequence" element={<WaytrixLogin />} />
                <Route path="/AddVideoSeq" element={<WaytrixLogin />} />
                <Route path="/Watches" element={<WaytrixLogin />} />
                <Route path="/AddWatch" element={<WaytrixLogin />} />
              </>
            }
          </Routes>
        </Suspense>
      </Router>
    </div>
  );
}

export default App;
